import { Component, Inject, LOCALE_ID } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { MessageService } from 'primeng/api';
import { OpsappService } from '../../services/opsapp.service';
import { DOCUMENT, formatDate } from '@angular/common';
import { Chart } from 'chart.js';
import annotationPlugin from 'chartjs-plugin-annotation';

@Component({
  selector: 'app-sensors',
  templateUrl: './sensors.component.html',
  styleUrls: ['./sensors.component.css']
})
export class SensorsComponent {

  
  sensors: any;
  loading: boolean = true;
  graphModal: boolean = false;
  selectedSensor: any;
  hoursBack: number = 4;
  multipleSensors: boolean = false;
  
  labels: any;
  datasets: {}[] = [];
  data: any;
  chartData: any;
  options: any;
  documentStyle: any;

  //colors: string[] = ["--blue-500", "--red-500", "--green-500", "--yellow-500", "--purple-500", "--teal-500"];


  constructor(private opsappService: OpsappService,
    @Inject( LOCALE_ID ) private locale: string,
    @Inject(DOCUMENT) private document: Document){
  }

  ngOnInit(){
    this.documentStyle = getComputedStyle(document.documentElement);
    Chart.register(annotationPlugin);
    this.loadData();
  }

  setChartOptions(){
    this.options = {
      maintainAspectRatio: false,
      aspectRatio: .6,
      scales: {
        y: {
          grid: {
            color: this.graphLineColorFunction
          }
        },
        x: {
          grid: {
            color: this.graphLineColorFunction
          }
        }
      },
      elements: {
        point:{
            radius: 0
        }
      }
    };
  }

  loadData(){
    this.loading = true;
    this.opsappService.getSensors().then(sensors => {
      this.sensors = sensors;
      this.clearSelection();
      this.loading = false;
    });
  }

  clearSelection(){
    this.sensors.forEach((sensor: any) => {
      sensor.checked = false;
    });
  }

  openGraph(){
    this.datasets = [];
    var colorIndex = 0;
    this.sensors.forEach((sensor:any) => {
      if(sensor.checked)
      {
        this.loadSensor(sensor, colorIndex);
        colorIndex++;
      }  

    });
    this.setChartOptions();
    this.options.plugins = {}
    this.chartData = {labels: this.labels, datasets: this.datasets};
  }

  sensorClicked(sensor: any){
    if (this.multipleSensors)
      sensor.checked = !sensor.checked;
    else
    {
      this.datasets = [];
      this.selectedSensor = sensor;
      this.setChartOptions();
      this.options.plugins = {
        annotation: {
          annotations: {
            box1: {
              type: "box",
              yMin: sensor.lowerLimit,
              yMax: sensor.upperLimit,
              xMin: 0,
              xMax: 100000,
              backgroundColor: this.getSensorRangeColor()
            }
          }
        }
      }  
      this.loadSensor(sensor, 0);
    }
  }
  
  getRandomColor() {
    var length = 6;
    var chars = '0123456789ABCDEF';
    var hex = '#';
    while (length--) hex += chars[(Math.random() * 16) | 0];
    return hex;
  }

  loadSensor(sensor: any, colorIndex: number){
    this.graphModal = true;
    var sensorReadingOptions = {
       SensorId: sensor.sensorId,
       HoursBack: this.hoursBack
    }
    this.opsappService.getSensorReading(sensorReadingOptions).then(data => {
      this.labels = data.map((x:any) => {
        return formatDate(x.dateRead, "MM-dd hh:mm", this.locale);
      });
      this.data = data.map((x:any) => {
        return x.reading;
      });
      var color = this.getRandomColor();
      this.datasets.push({label: sensor.sensorName, data: this.data, tension: .4, 
        borderColor: color});
      this.chartData = {labels: this.labels, datasets: this.datasets};
      
      console.log(data);
    });
  }

  getReadingClass(sensor: any){
    if (sensor.isStage1Alarming || sensor.isStage2Alarming){
      return "text-red-500";
    }
    else
    {
      return "text-green-500";
    }
  }

  canOpenGraph(){
    return (this.multipleSensors && this.sensors.some((sensor:any) => sensor.checked));
  }

  graphLineColorFunction(context:any){
    var docStyle = getComputedStyle(document.documentElement);
    return docStyle.getPropertyValue('--text-color');
  }

  getSensorRangeColor(){
    var themeLink = this.document.getElementById("app-theme") as HTMLLinkElement;
    if (themeLink && themeLink.href.includes("dark"))
      return 'rgba(255, 255, 255, 0.20)';
    else
      return 'rgba(0, 100, 0, 0.10)';
  }
  
}
